import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'loyaltic-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDialogComponent implements OnInit {

  @Input() modalId: string = 'modal-dialog';

  culture ='';
  brand: string | null = null;

  constructor(public translate: TranslateService) { 
    this.culture = translate.getDefaultLang();
    this.culture = localStorage.getItem('currLanguage')!;
  }

  ngOnInit() {
    this.brand = localStorage.getItem('brand');
  }

}
